import * as React from "react";
const SvgFiRrSandwich = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sandwich_svg__a)">
      <path
        fill="#062147"
        d="M21 18H3a3 3 0 1 0 0 6h18a3 3 0 0 0 0-6m0 4H3a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2m1.8-16.626-3.113-3.627a4.97 4.97 0 0 0-5.8-1.328L3 5.184a5 5 0 0 0-3 4.581A3.024 3.024 0 0 0 3 13h18a3 3 0 0 0 3-3 6.17 6.17 0 0 0-1.2-4.626m-8.112-3.123a2.99 2.99 0 0 1 3.48.8c.092.126 3.395 3.91 3.34 3.952H3.835zM22 10.001a1 1 0 0 1-1 1H3c-1.051 0-1.14-1.225-.895-2H22zm2 6a.99.99 0 0 1-1.584.79l-.011.013c-.386-.255-1.284-1.224-1.96-.638a4.01 4.01 0 0 1-4.89 0 .94.94 0 0 0-1.11 0 4.06 4.06 0 0 1-4.89 0 .94.94 0 0 0-1.11 0 4.06 4.06 0 0 1-4.89 0c-.67-.589-1.588.39-1.96.637l-.011-.014A.982.982 0 0 1 .416 15.21l-.011-.01s.573-.423.816-.612a2.946 2.946 0 0 1 3.558 0 2.03 2.03 0 0 0 2.443 0 2.946 2.946 0 0 1 3.557 0 2.03 2.03 0 0 0 2.443 0 2.945 2.945 0 0 1 3.557 0 2.03 2.03 0 0 0 2.443 0 2.946 2.946 0 0 1 3.557 0c.243.19.815.611.816.612l-.011.014A.98.98 0 0 1 24 16"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sandwich_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSandwich;
